import { createContext, useContext, useEffect, useState } from "react";
import UserSessionService from '@/lib/UserSessionService'
import { UserTypes } from "@/configs/AppConfig";
import { MOD_AUTH } from "@/configs/ModulesConfig";
import api from "@/api/api"

// import { useNavigate } from "react-router-dom";
// import { useLayout } from "./LayoutProvider";

const SessionContext = createContext(null);

const data = [
    {
        "id": "usr1",
        "email": "kevin@email.com",
        "password": "1234",
        "user": {
            "email": "kevin@email.com",
            "name": "Kevin Warsh",
            "image": null
        }
    },
    {
        "id": "usr2",
        "email": "sarah@email.com",
        "password": "1234",
        "user": {
            "email": "sarah@email.com",
            "name": "Sarah Jenkins",
            "image": "https://example.com/avatars/sarah.jpg"
        }
    },
    {
        "id": "usr3",
        "email": "mike@email.com",
        "password": "1234",
        "user": {
            "email": "mike@email.com",
            "name": "Michael Torres",
            "image": null
        }
    },
    {
        "id": "usr4",
        "email": "linda@email.com",
        "password": "1234",
        "user": {
            "email": "linda@email.com",
            "name": "Linda Belcher",
            "image": "https://example.com/avatars/linda.png"
        }
    },
    {
        "id": "usr5",
        "email": "alex@email.com",
        "password": "1234",
        "user": {
            "email": "alex@email.com",
            "name": "Alex Chen",
            "image": null
        }
    }
]


const SessionProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userType, setUserType] = useState(null)
    const [rights, setRights] = useState([])

    useEffect(() => {
        const loginData = {
            user: UserSessionService.getUser(),
            userType: UserSessionService.getUserType(),
            rights: UserSessionService.getRights(),
        }
        const key = UserSessionService.getUserKeyObj()
        if ((loginData.userType == UserTypes.APP_USER || loginData.userType == UserTypes.SYSTEM_USER) && !!key) {
            setIsAuthenticated(true)
            setUser(loginData.user)
            setUserType(loginData.userType)
            setRights(loginData.rights)
        }
        else {
            setIsAuthenticated(false)
            setUser(null)
            setUserType(UserTypes.GUEST)
            setRights([])
            UserSessionService.removeSession()
        }
    }, [isAuthenticated])

    async function loginAsAppUser(email, password) {
        const response = await api.patch(MOD_AUTH.api_app_user.auth, {
            email,
            password
        })
        const badRequest = response.status !== 201
        const statusCode = response?.data?.status
        const message = response?.data?.message

        if (message && statusCode < 0) {
            throw {
                message: message
            };
        }
        if (badRequest || !response?.data?.sessionDependencies) {
            throw {
                message: message || 'Log in failed'
            };
        }
        const data = {
            user: {
                name: response.data.sessionDependencies.name,
                email: response.data.sessionDependencies.email,
            },
            userKey: response.data.sessionDependencies.userKey,
        }
        UserSessionService.setSession(UserTypes.APP_USER, data.user, data.userKey, [])
        setIsAuthenticated(true)
        return data
    }
    async function loginAsSystemUser(email, password) {
        const response = await api.patch(MOD_AUTH.api_system_user.auth,
            {
                email,
                password
            }
        )
        const badRequest = response.status !== 201
        const statusCode = response?.data?.status
        const message = response?.data?.message

        if (message && statusCode < 0) {
            throw {
                message: message
            };
        }
        if (badRequest || !response?.data?.sessionDependencies) {
            throw {
                message: message || 'Log in failed'
            };
        }
        const data = {
            user: {
                name: response.data.sessionDependencies.name,
                email: response.data.sessionDependencies.email,
            },
            rights: response.data.sessionDependencies.accessibleModuleCodes,
            userKey: response.data.sessionDependencies.userKey,
        }
        UserSessionService.setSession(UserTypes.SYSTEM_USER, data.user, data.userKey, data.rights)
        setIsAuthenticated(true)
        return data
    }
    async function logout() {
        const api_url = userType == UserTypes.SYSTEM_USER ? MOD_AUTH.api_system_user.logout : MOD_AUTH.api_app_user.logout
        await api.post(api_url)
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                UserSessionService.removeSession()
                setIsAuthenticated(false)
            })

    }

    function updateRights(rights, error = false) {
        if (error) {
            logout()
            return
        }
        setRights(rights)
        UserSessionService.setRights(rights)
    }

    return (
        <SessionContext.Provider
            value={{
                user,
                isAuthenticated,
                userType,
                rights,
                loginAsAppUser,
                loginAsSystemUser,
                logout,
                updateRights
            }}
        >
            {children}
        </SessionContext.Provider>
    );
};

export default SessionProvider;

export const useSession = () => useContext(SessionContext);